import { render, staticRenderFns } from "./CouponHistory.vue?vue&type=template&id=03c636bb&scoped=true"
import script from "./CouponHistory.vue?vue&type=script&lang=js"
export * from "./CouponHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c636bb",
  null
  
)

export default component.exports